import { Reducer } from 'redux'

import { AuthenticationState, AuthenticationTypes } from './types'

const INITIAL_STATE: AuthenticationState = {
  cpfAuthentication: undefined,
  userNameAuthentication: undefined,
}

const reducer: Reducer<AuthenticationState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthenticationTypes.SET_CPF_AUTHENTICATION:
      return { ...state, cpfAuthentication: action.payload }
    case AuthenticationTypes.SET_USERNAME_AUTHENTICATION:
      return { ...state, userNameAuthentication: action.payload }
    default:
      return state
  }
}

export default reducer
